module.exports = __webpack_public_path__ + "static/media/Quam-Icon-ClearList.7c48d20f.svg";